import template from "./cost-modal-pricing.html";

const CostModalPricingComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
    resolve: "<",
  },
  template: template,
  controller: class CostModalPricingController {
    /* @ngInject */
    constructor($rootScope, $q, $filter, ModalsManager, CostFolder, Cost, Notification) {
      this.$rootScope = $rootScope;
      this.$q = $q;
      this.$filter = $filter;
      this.ModalsManager = ModalsManager;
      this.CostFolder = CostFolder;
      this.Cost = Cost;
      this.NotificationService = Notification;
    }

    async $onInit() {
      this.rootFolder = {
        _id: null,
        name: this.$filter("trans")("costFolder.main"),
      };
      this.editMode = this.resolve.editMode;
      this.openedCostLibrary = false;
      this.saveOnLibrary = false;
      this.searchText = "";
      this.parentCostFolder = {};
      this.folders = [];
      this.costs = [];
      this.searchOptions = { name: "", page: 1 };

      this.cost = this.resolve.cost ? angular.copy(this.resolve.cost) : new this.Cost();
      this.saving = false;
      if (!this.cost.currency) this.setCurrency(this.$rootScope.organization.settings.currency);

      await this.refresh(this.rootFolder);
      this.$rootScope.$applyAsync();

      this.$rootScope.$watch(
        () => this.searchOptions.name,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            if (newVal.length === 0) this.refresh(this.rootFolder).then();
            else this.findBySearchText().then();
            if (!this.openedCostLibrary) this.toggleOpenedCostLibrary();
          }
        },
      );
    }

    selectCost(cost) {
      this.close({ $value: cost });
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }

    async findBySearchText() {
      this.loading = true;
      this.searchOptions.page = 1;
      const data = await this.$q
        .all({
          costFolderPromise: this.CostFolder.query({
            q: this.searchOptions.name,
          }),
          costPromise: this.Cost.query({
            q: this.searchOptions.name,
            page: this.searchOptions.page,
          }),
          costsCountPromise: this.Cost.getCount({ q: this.searchOptions.name }),
        })
        .then((values) => {
          return {
            folders: values.costFolderPromise,
            costs: values.costPromise,
            costsCount: values.costsCountPromise,
          };
        });
      this.folders = data.folders;
      this.costs = data.costs;
      this.costsCount = data.costsCount;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async refresh(parent) {
      this.loading = true;
      const data = await this.$q
        .all({
          costFolderPromise: this.CostFolder.queryByParent(parent._id),
          costPromise: this.Cost.queryByParent(parent._id, this.searchOptions.page),
          costsCountPromise: this.Cost.getCount({
            parent: parent._id || "null",
          }),
        })
        .then((values) => {
          return {
            folders: values.costFolderPromise,
            costs: values.costPromise,
            costsCount: values.costsCountPromise,
          };
        });
      this.parentCostFolder = parent;
      this.folders = data.folders;
      this.costs = data.costs;
      this.costsCount = data.costsCount;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async loadMoreCosts() {
      const loadedCosts = this.costs.length;
      const costsToLoad = this.costsCount;
      if (loadedCosts < costsToLoad && !this.loading) {
        this.searchOptions.page++;
        const costs = await this.loadCosts();
        this.costs = this.costs.concat(costs);
        this.$rootScope.$applyAsync();
      }
    }

    async loadCosts() {
      this.loading = true;
      let costs = [];

      if (this.searchOptions.name === "")
        costs = await this.Cost.queryByParent(this.parentCostFolder._id, this.searchOptions.page);
      else
        costs = await this.Cost.query({
          q: this.searchOptions.name,
          page: this.searchOptions.page,
        });

      this.loading = false;
      this.$rootScope.$applyAsync();
      return costs;
    }

    async loadCostFolder(parentCostFolderId) {
      if (parentCostFolderId) {
        const parentCostFolder = await this.CostFolder.get(parentCostFolderId);
        await this.refresh(parentCostFolder);
        this.parentCostFolder = parentCostFolder;
      } else {
        await this.refresh(this.rootFolder);
      }
      this.$rootScope.$applyAsync();
    }

    setCurrency(oldCurrency, newCurrency) {
      this.cost.currency = newCurrency || oldCurrency;
    }

    toggleOpenedCostLibrary() {
      this.openedCostLibrary = !this.openedCostLibrary;
    }

    toggleSaveOnLibrary() {
      this.saveOnLibrary = !this.saveOnLibrary;
    }

    async save() {
      if (!this.form.$valid) return;
      if (this.saveOnLibrary) {
        this.saving = true;
        if (
          !(this.cost instanceof this.Cost) &&
          typeof this.cost.existsOnLibrary === "function" &&
          !this.cost.existsOnLibrary()
        ) {
          // Creacion del coste desde un cost snapshot
          const costSnapshot = this.cost;
          this.cost = new this.Cost();
          this.cost.setDataFromCostSnapshot(costSnapshot);
          this.cost.parent = null;
          await this.cost.create();
        } else if (typeof this.cost.existsOnLibrary === "function" && this.cost.existsOnLibrary()) {
          // Edición del coste desde un snapshot
          const costSnapshot = this.cost;
          this.cost = new this.Cost();
          this.cost.setDataFromCostSnapshot(costSnapshot);
          this.cost._id = costSnapshot.from;
          this.cost.parent = null;
          await this.cost.save();
        } else {
          // Edición del coste desde cero
          this.cost.parent = null;
          await this.cost.save();
        }
        this.saving = false;
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.costSaved"),
        });
      } else this.cost._id = null;
      this.close({ $value: this.cost });
      this.$rootScope.$applyAsync();
    }
  },
};

export default CostModalPricingComponent;
